export default {
  SOMETHING_WENT_WRONG: "Something went wrong",
  PAGE_NOT_ALLOWED: "You are not allowed to access this page",
};
